import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Grow, Popover } from "@mui/material";
import { useRef } from "react";
import { useColorPicker } from "../hooks/useColorPicker.js";
function ColorPickerPopover(props) {
  const { Component, onSetOpen, open, children, testId = "ColorPickerPopover", ...triggerExtraProps } = props;
  const anchorRef = useRef(null);
  const { color } = useColorPicker();
  const handleClose = () => {
    onSetOpen(false);
  };
  const handleOpen = () => {
    onSetOpen(true);
  };
  return /* @__PURE__ */ jsxs(Box, { "data-testid": testId, ref: anchorRef, children: [
    /* @__PURE__ */ jsx(Component, { color, onClick: handleOpen, open, ...triggerExtraProps }),
    /* @__PURE__ */ jsx(
      Popover,
      {
        anchorEl: anchorRef.current,
        anchorOrigin,
        onClose: handleClose,
        open,
        TransitionComponent: Grow,
        transformOrigin,
        children
      }
    )
  ] });
}
const anchorOrigin = { horizontal: "left", vertical: "bottom" };
const transformOrigin = { horizontal: 0, vertical: -8 };
export {
  ColorPickerPopover
};
//# sourceMappingURL=ColorPickerPopover.js.map
